import React from 'react';
import Slider from 'react-slick';
import CarouselItem from '../CarouselItem/CarouselItem';
import CarouselNextArrow from '../CarouselNextArrow/CarouselNextArrow';
import CarouselPrevArrow from '../CarouselPrevArrow/CarouselPrevArrow';
import testimonialPic from '../../images/testimonial-dp.png';
import testimonialVid from '../../images/testimonial-video.svg';
import './Carousel.scss';

const Carousel = () => {
  const settings = {
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    nextArrow: <CarouselNextArrow />,
    prevArrow: <CarouselPrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          nextArrow: false,
          prevArrow: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          nextArrow: false,
          prevArrow: false,
        },
      },
    ],
  };

  return (
    <div className="carousel">
      <Slider {...settings} className="inner-div">
        <CarouselItem
          name="Mario Cummings"
          title="Brand Design Manager at IBM"
          image={testimonialPic}
          text="This is Gem I really love it. If you know Project Huddle, you shouldn’t let it go! This tool is fast for collecting, managing, and previewing design feedback on live websites. I can easily create mockups live from "
        />
        <CarouselItem
          name="Mario Cummings"
          title="Brand Design Manager at IBM"
          video={testimonialVid}
        />
        <CarouselItem
          name="Mario Cummings"
          title="Brand Design Manager at IBM"
          image={testimonialPic}
          text="This is Gem I really love it. If you know Project Huddle, you shouldn’t let it go! This tool is fast for collecting, managing, and previewing design feedback on live websites. I can easily create mockups live from "
        />
        <CarouselItem
          name="Mario Cummings"
          title="Brand Design Manager at IBM"
          image={testimonialPic}
          text="This is Gem I really love it. If you know Project Huddle, you shouldn’t let it go! This tool is fast for collecting, managing, and previewing design feedback on live websites. I can easily create mockups live from "
        />
        <CarouselItem
          name="Mario Cummings"
          title="Brand Design Manager at IBM"
          image={testimonialPic}
          text="This is Gem I really love it. If you know Project Huddle, you shouldn’t let it go! This tool is fast for collecting, managing, and previewing design feedback on live websites. I can easily create mockups live from "
        />
      </Slider>
    </div>
  );
};

export default Carousel;
